
import Popup from "../../../components/Popup";
import React, {useState} from "react";
import {Biscuit} from "../../../../utils";
import t from "../../../helpers/t";
// @ts-ignore
import AbonnementsListItem from "./AbonnementsListItem";
// @ts-ignore
import { rbac } from '../index';
import {userActions} from "inbooma-api";
import {getDuration} from "../../../../utils/Helper";
const AbonnementsItem = (props:any) => {
    const { abonnement, dispatch, getList, deleteAbonnement, filter, setFilter, sort, setSort, _key, setKey } = props;
    const language = Biscuit.get('user.lang').replace('-','_');
    const [ready,setReady] = useState(false);
    const [popup,setPopup]:any = useState({
        open: false,
        linkText: "",
        link: ""
    });
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;
    let abonnementsData:{elements: any, addClasses: string}|null = null;
    const fillData = () => {
        let hasResources = false;
        let toggle = false;
        if(typeof searchParams.get("item") !== 'undefined' && searchParams.get("item") !== null && abonnement.id === Number(searchParams.get("item"))){
            toggle=true;
        }

        let addClasses:string = '';
        /* if (contingent.status === 'cancelled') {
             addClasses += ' is-cancelled';
         }*/
        let showSpecial = true;
        if(abonnement.admin && Biscuit.get('user.is_superuser') != 'true'){
            showSpecial = false;
        }

        if(toggle){
            addClasses += ' toggled';
        }
        let elements;
        elements = [
            {
                type: "text",
                value: "description",
                title: t('description'),
                extraTopClasses: "show-label",
                data:
                    [{
                        value: "description",
                        text: abonnement.description,
                        extraClasses: "text-small",
                        title: t('description', null, 'capital')
                    }],
                largeWidth: 3,
                mediumWidth: 12,
                smallWidth: 12,
                handler: onItemClickedHandler
            },
            {
                type: "text",
                value: "interval",
                title: t('interval'),
                extraTopClasses: "show-label",
                data:
                    [{
                        value: "interval",
                        text: abonnement.intervalAmount + ' ' + t(abonnement.intervalUnit),
                        extraClasses: "text-small",
                        title: t('interval', null, 'capital')
                    }],
                largeWidth: 2,
                mediumWidth: 12,
                smallWidth: 12,
                handler: onItemClickedHandler
            },
            {
                type: "text",
                value: "duration",
                title: t('duration'),
                extraTopClasses: "show-label",
                data:
                    [{
                        value: "duration",
                        text: getDuration(abonnement.duration,false,false,true),
                        extraClasses: "text-small",
                        title: t('duration', null, 'capital')
                    }],
                largeWidth: 2,
                mediumWidth: 12,
                smallWidth: 12,
                handler: onItemClickedHandler
            },
            {
                type: "text",
                value: "minDuration",
                title: t('minimal duration'),
                extraTopClasses: "show-label",
                data:
                    [{
                        value: "minDuration",
                        text: getDuration(abonnement.minDuration,false,false,true),
                        extraClasses: "text-small",
                        title: t('minimal duration', null, 'capital')
                    }],
                largeWidth: 2,
                mediumWidth: 12,
                smallWidth: 12,
                handler: onItemClickedHandler
            },
            {
                type: "text",
                value: "amount",
                title: t('amount'),
                extraTopClasses: "show-label",
                data:
                    [{
                        value: "amount",
                        text: abonnement.amount + '€',
                        extraClasses: "text-small",
                        title: t('amount', null, 'capital')
                    }],
                largeWidth: 2,
                mediumWidth: 12,
                smallWidth: 12,
                handler: onItemClickedHandler
            }];
         if(showSpecial) {
             elements.push({
                 type: "specialButtons",
                 title: t('list'),
                 data: [{
                     value: abonnement,
                     // @ts-ignore
                     icon: "inb-fi-list",
                     extraClasses: "inb-round-btn hollow round float-left",
                     ref: "#",
                     round: true,
                     type: 'open',
                     handler: getList,
                     title: t('list')
                 }],
                 mediumWidth: 1,
                 smallWidth: 1
             });
         }

        /* if(hasCheckIn) {
             elements.push({
                 type: "bar",
                 value: "state",
                 title: "",
                 data: [{
                     value: "state",
                     text: getState(contingent),
                     extraClasses: getStateClasses(contingent),
                     extra: (contingent.checkins[0].checkout !== null ? 'has-checkout' : ""),
                     title: ""
                 }],
                 mediumWidth: 12,
                 smallWidth: 12,
                 handler: onItemClickedHandler
             });
         }*/
        /* if (contingent.status !== 'cancelled') {
             elements.push({
                 type: "button",
                 value: (typeof contingent.checkins === 'undefined' || contingent.checkins.length === 0) ? t('checkin_contingents', null, 'capital') : t('checkout_contingents', null, 'capital'),
                 title: (typeof contingent.checkins === 'undefined' || contingent.checkins.length === 0) ? t('checkin_contingents', null, 'capital') : t('checkout_contingents', null, 'capital'),
                 extraTopClasses: "inb-contingents__pdf2",
                 data: [{
                     value: contingent.id,
                     icon: "inb-fi-checkin",
                     extraClasses: "inb-round-btn hollow round float-left",
                     ref: "/ContingentsList/" + contingent.id + "/checkin",
                     round: true
                 }],
                 mediumWidth: 1,
                 smallWidth: 1
             });
         }*/



        if(elements.length > 0) {

            abonnementsData = {
                elements: elements,
                addClasses: addClasses
            };
        }
    }

    const onItemClickedHandler = (value:any) => {

        console.log("clicked on: ", value);
        if (value.startsWith('acc_invoice_')) {

            // open accumulated invoice
            const id = value.split('acc_invoice_')[1];


        }
        if (value.startsWith('user_')) {

            // fetch user info
            const id = value.split('user_')[1];
            const el_rect = document.getElementsByName(value)?.[0]?.getBoundingClientRect();

            props.dispatch(userActions.getUser({
                token: Biscuit.get('token'),
                id: id,
                parameters: {
                    headers: {
                        "Accept-Language": language,
                        "Content-Language": language
                    }
                }
            }));
               setPopup({
                ...popup,
                left: el_rect?.left + "px",
                top: el_rect?.top + "px",
                text: t('user',null,'capital') + ':'
            });
        }
        if (value.startsWith('payment_info_')) {

            const idx = value.split('payment_info_')[1];
            const el_rect = document.getElementsByName(value)?.[0]?.getBoundingClientRect();

            setPopup({
                ...popup,
                left: el_rect?.left + "px",
                top: el_rect?.top + "px",
                open: true,
                text: t('payment_error_info') + ": " + props.wallets[idx].message,
                link: "",
                linkText: ""
            });
        }
    };

    const popupCloseHandler = () => {

        setPopup({
            ...popup,
            open: false
        });
    };
    const getMenu = (abonnement: any) => {
        let abonnementMenu = [];
        if(abonnement.admin && Biscuit.get('user.is_superuser') != 'true'){
            return [];
        }
        if(rbac.hasPermission('editAbonnement')) {
            abonnementMenu.push({
                text: t('edit'),
                href: "/abonnements/" + abonnement.id + currentUrl.search,
                iconClass: "fi fi-wrench",
                title: "edit"
            });
        }

            if (rbac.hasPermission('deleteAbonnement')) {
                abonnementMenu.push({
                    text: t('delete'),
                    href: "#",
                    clickHandler: deleteAbonnement,
                    getItem: 'abonnement',
                    abonnement: abonnement,
                    iconClass: "fi fi-trash",
                    title: "delete"
                })
            }
            return abonnementMenu;
    }
    fillData();
    return (
        <>
        {abonnementsData !== null && <AbonnementsListItem
                            abonnement={abonnement}
                            refLink={"abonnements"}
                            dispatch={dispatch}
                            listStyle="tight"
                            id={"row-" + abonnement.id}
                            // @ts-ignore
                            overwriteClasses={"inb-c-item inb-c-item--order inb-c-item-abonnements row" + abonnementsData.addClasses}
            // @ts-ignore
                            elements={abonnementsData.elements}
                            setFilter={setFilter}
                            filter={filter}
                            setNKey={setKey}
                            sort={sort}
                            setSort={setSort}
                            menu={
                                getMenu(abonnement)
                            }
                        />
            }


            {popup.open === true &&
                <Popup
                    left={popup.left}
                    top={popup.top}
                    linkText={popup.linkText}
                    text={popup.text}
                    link={popup.link}
                    onCloseHandler={popupCloseHandler}/>
            }
        </>
    );
}

export default AbonnementsItem;